import { PageHeader } from '@/components/layout/PageHeader';
import { PatientRTPDownloadBuilder } from '@/components/features/rtp-download/PatientRTPDownloadBuilder';

export function PatientRTPDownload() {
  return (
    <div>
      <PageHeader
        title="Download RTP Data"
        description="Configure time range and grouping to download your RTP sensor data"
      />

      <PatientRTPDownloadBuilder />
    </div>
  );
}
